import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { ProductImageSizesPortraitEnum } from '@as-react/common-types';
import { getImageUrlForBasketTile } from '../../../util/ImageUtil';
import { Box, ProductTile, ProductTileHorizontal, ProductTileImage, StackBlock, TextAlpha, } from '@yonderland/andes-react';
import { capitalizeOnly } from '@as-react/common-utils';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { useTranslation } from 'react-i18next';
import AsNumeral from '../../../vendors/asNumeral';
import { usePriceProps } from '../../../hooks/usePriceProps';
export const ProductTileOrderOverview = ({ product }) => {
    const { t } = useTranslation(I18N_NAMESPACES.navigation);
    const { currency, productImageConfig, feature_toggles: { lowest_price_all }, } = useAemConfig();
    const image = getImageUrlForBasketTile(product, productImageConfig, ProductImageSizesPortraitEnum.bundles);
    const color = product.color ? capitalizeOnly(product.color) : '';
    const size = product.sizeDescription || product.originalSize;
    const getSizeColorLabel = () => {
        if (size !== '.' && color) {
            return t(`${I18N_NAMESPACES.navigation}:basket.flyout.options`, {
                size: size,
                color: color,
            });
        }
        else if (size !== '.' && !color) {
            return t(`${I18N_NAMESPACES.navigation}:basket.flyout.options.size`, {
                size: size,
            });
        }
        else if ((size === '.' && color) || !size) {
            return t(`${I18N_NAMESPACES.navigation}:basket.flyout.options.color`, {
                color: color,
            });
        }
        return '';
    };
    const priceActual = {
        formattedPrice: AsNumeral.formatAsCurrency(product.totalPrice),
    };
    const pricePrevious = product.productHasDiscount && !!product.totalPreviousPrice
        ? {
            formattedPrice: AsNumeral.formatAsCurrency(product.totalPreviousPrice),
        }
        : undefined;
    const priceReference = product.productHasDiscount && !!product.lowestPrice
        ? {
            formattedPrice: AsNumeral.formatAsCurrency(product.lowestPrice),
        }
        : undefined;
    const priceProps = usePriceProps({
        priceInformation: {
            prices: product.prices,
            hasDiscount: Boolean(product.productHasDiscount),
        },
        enablePriceReference: lowest_price_all,
        fallbackPriceViewModel: {
            priceActual,
            pricePrevious,
            priceReference,
        },
    });
    return (_jsxs(ProductTileHorizontal, { gap: "3", product: Object.assign(Object.assign({ image,
            currency }, priceProps), { title: product.description, brand: product.brand }), testId: "product_tile", children: [_jsx(ProductTile.Cell, { section: "media", children: _jsx(ProductTileImage, { height: 120, width: 80 }) }), _jsx(ProductTile.Cell, { section: "content", children: _jsxs(StackBlock, { gap: "5", children: [_jsx(ProductTile.Title, { brandOnTheSameLine: true, lineClamp: 2 }), _jsxs(TextAlpha, { color: "subtle", children: [product.quantity > 1 && (_jsxs(_Fragment, { children: [t(`${I18N_NAMESPACES.checkout}:checkout.basket.count`, { count: product.quantity }), ", "] })), getSizeColorLabel()] }), _jsx(Box, { marginInlineStart: "auto", children: _jsx(ProductTile.Price, { align: "end" }) })] }) })] }));
};
